import { render, staticRenderFns } from "./DaftarEditGadai.vue?vue&type=template&id=9baa7f0c&"
import script from "./DaftarEditGadai.vue?vue&type=script&lang=js&"
export * from "./DaftarEditGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports